import { MdOutlineClose } from "react-icons/md";

const OrderDetailsModal = ({ isOpen, closeModel, ele }) => {
  if (!isOpen) {
    return null;
  }

  const { referenceId } = ele;

  return (
    <div className="fixed inset-0 flex items-center justify-center z-40 bg-black bg-opacity-50">
      <div className="relative bg-[#FAFAFA] border-[#D2D2D2] text-black rounded-[6px] lg:max-w-4xl w-11/12">
        <div className="flex justify-between items-start px-6 pt-4">
          <div>
            <h1 className="text-xl font-bold text-black">Order Details</h1>
          </div>
          <div
            className="w-8 h-8 cursor-pointer rounded-full bg-[#ECECEC] hover:bg-[#ECECEC]/80 flex justify-center items-center"
            onClick={closeModel}
          >
            <MdOutlineClose title="Close" />
          </div>
        </div>

        <div className="p-6">
          <div className="flex items-center gap-2 font-semibold text-gray-800 border-b pb-2 mb-3">
            <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
            Order Information
          </div>

          {/* Buyer and Seller Details */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm mb-4">
            <div>
              <div className="text-gray-600 font-medium">Buyer:</div>
              <div className="font-semibold">{referenceId.buyerId.name}</div>
              <div className="text-xs text-gray-500">{referenceId.buyerId.email}</div>
            </div>
            <div>
              <div className="text-gray-600 font-medium">Seller:</div>
              <div className="font-semibold">{referenceId.sellerId.name}</div>
              <div className="text-xs text-gray-500">{referenceId.sellerId.email}</div>
            </div>
          </div>

          {/* Trade Amount and Currency */}
          <div className="grid grid-cols-2 gap-x-4 gap-y-2 text-sm mb-3">
            <div className="text-gray-600">Amount:</div>
            <div className="font-semibold">{Number(referenceId.tradeAmount).toFixed(2)}</div>
            <div className="text-gray-600">Currency:</div>
            <div className="font-semibold">{referenceId.currency}</div>
          </div>

          <div className="border-t pt-2 mb-3">
            <div className="text-xs text-gray-500 mb-2">Order Status:</div>
            <div className="flex items-center justify-between">
              <span className="text-xs text-gray-500">Status:</span>
              <div className="flex items-center gap-2">
                <div
                  className={`w-2 h-2 rounded-full ${
                    referenceId.orderStatus === "PENDING"
                      ? "bg-yellow-400 animate-pulse"
                      : referenceId.orderStatus === "COMPLETED"
                      ? "bg-green-400"
                      : "bg-red-400"
                  }`}
                ></div>
                <span
                  className={`px-2 py-1 rounded-full text-xs font-medium ${
                    referenceId.orderStatus === "PENDING"
                      ? "bg-yellow-100 text-yellow-700"
                      : referenceId.orderStatus === "COMPLETED"
                      ? "bg-green-100 text-green-700"
                      : "bg-red-100 text-red-700"
                  }`}
                >
                  {referenceId.orderStatus?.toUpperCase()}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderDetailsModal;